import React from "react";

interface DashboardSectionProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

function cn(...classes: Array<string | undefined>) {
  return classes.filter(Boolean).join(" ");
}

export const DashboardSection: React.FC<DashboardSectionProps> = ({ title, children, className }) => {
  return (
    <section className={cn("space-y-3", className)}>
      <h2 className="text-lg font-semibold text-slate-900 dark:text-slate-50">{title}</h2>
      <div className="mm-surface p-4 sm:p-5">
        {children}
      </div>
    </section>
  );
};
